import { TipoFuncionalidad } from '../../../utils/enums';
import { useUserRolesContext } from '../../../context/userRolesContext';


/**
 * Hook para gestionar permisos en el módulo de Detalle de Mutuo.
 * 
 * Calcula permisos base que consideran dos contextos:
 * - Bandeja: Permite editar cuando NO es vigente y tiene permiso Bandeja_editar
 * - Cartera: Permite editar cuando ES vigente y tiene permisos Cartera_editar_*
 * 
 * @param esVigente - Indica si el mutuo está vigente
 * @returns Permisos calculados para Bandeja y Cartera
 */
export const useDetalleMutuoPermissions = (esVigente?: boolean) => {
    const { hasPermission } = useUserRolesContext();

    const permisoBandejaVer = hasPermission(TipoFuncionalidad.Bandeja_ver) && !esVigente;
    const permisoBandeja = hasPermission(TipoFuncionalidad.Bandeja_editar) && !esVigente;
    const permisoCarteraInfo = hasPermission(TipoFuncionalidad.Cartera_editar_info) && esVigente;
    const permisoCarteraContacto = hasPermission(TipoFuncionalidad.Cartera_editar_contacto) && esVigente;

    return {
        permisoBandeja,
        permisoBandejaVer,
        permisoCarteraInfo,
        permisoCarteraContacto
    };
};
